module.exports = __webpack_public_path__ + "static/media/amt-logo-white.be57baaf.png";